import React from 'react';
import './ContactPage.css';

const ContactPage = () => {
  return (
    <div className="contact-page">
      <div className="contact-hero">
        <h1>Get in Touch</h1>
        <p className="contact-subtitle">
          Have questions about tracking your Ireland visa? We're here to help you every step of the way.
        </p>
      </div>

      <div className="contact-grid">
        <div className="contact-card primary-card">
          <div className="contact-icon">📧</div>
          <h3>Email Support</h3>
          <p>Get detailed responses to your queries within 24 hours</p>
          <a href="mailto:visahelp@irelandvisatracker.in" className="contact-link">
            visahelp@irelandvisatracker.in
          </a>
          <div className="response-time">⚡ Average response: 24 hours</div>
        </div>

        <div className="contact-card">
          <div className="contact-icon">💬</div>
          <h3>Live Chat</h3>
          <p>Quick answers to common questions</p>
          <div className="availability">
            <span className="status-dot"></span>
            <span>Mon-Fri: 9 AM - 6 PM IST</span>
          </div>
        </div>

        <div className="contact-card">
          <div className="contact-icon">📱</div>
          <h3>Social Media</h3>
          <p>Follow us for updates and tips</p>
          <div className="social-links">
            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" aria-label="Twitter">🐦 Twitter</a>
            <a href="https://www.linkedin.com" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">💼 LinkedIn</a>
          </div>
        </div>
      </div>

      <div className="contact-section">
        <h2>Frequently Asked Questions</h2>
        <div className="faq-grid">
          <div className="faq-item">
            <h4>🕐 What are your support hours?</h4>
            <p>Our email support is available 24/7. We typically respond within 24 hours on business days.</p>
          </div>
          <div className="faq-item">
            <h4>🔄 How do I update my visa reference number?</h4>
            <p>Email us with your registered email address and new reference number. We'll update it within 2 hours.</p>
          </div>
          <div className="faq-item">
            <h4>💰 Can I get a refund?</h4>
            <p>Premium is a one-time, non-refundable purchase because monitoring setup and tool access begin after payment verification. Please read our <a href="/refund">refund policy</a>. If you have a billing error or service problem, contact us with your transaction ID so we can help.</p>
          </div>
          <div className="faq-item">
            <h4>🔐 Is my data secure?</h4>
            <p>Absolutely. We use industry-standard encryption and never share your data with third parties.</p>
          </div>
        </div>
      </div>

      <div className="contact-section office-info">
        <h2>Our Office</h2>
        <div className="office-card">
          <div className="office-details">
            <div className="office-icon">🏢</div>
            <div>
              <h3>SelfDriven Careers</h3>
              <p>Bangalore, Karnataka, India</p>
              <p className="office-note">Remote-first team serving visa applicants across India</p>
            </div>
          </div>
        </div>
      </div>

      <div className="contact-cta">
        <h2>Still have questions?</h2>
        <p>Don't hesitate to reach out. We're committed to helping you navigate your visa journey.</p>
        <a href="mailto:visahelp@irelandvisatracker.in" className="btn-primary">
          Send us an email →
        </a>
      </div>
    </div>
  );
};

export default ContactPage;
